<template>
  <div class="my-editor">
    <!-- 编辑区域 -->
    <div
      ref="editor"
      class="editor-content"
      contenteditable="true"
      :data-placeholder="placeholder"
      @input="handleInput"
      @mouseup="handleMouseUp"
      @click="closeColorPicker"
      @keydown="handleKeyDown"
    ></div>

    <!-- 工具栏 -->
    <div
      class=""
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;
      "
    >
      <div style="display: flex; align-items: center">
        <img
          v-if="menus.includes('image')"
          src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
          mode=""
          style="width: 18px; height: 18px; cursor: pointer; margin-right: 15px"
          @click="handleCaseProblemImg"
        />
        <img
          v-if="menus.includes('bold')"
          src="https://ossfastmake.mustke.com/wenjuan/tupian/bold-1777360921203.svg"
          mode=""
          style="width: 18px; height: 18px; cursor: pointer; margin-right: 15px"
          @click="execCommand('bold')"
        />
        <img
          v-if="menus.includes('underline')"
          src="https://ossfastmake.mustke.com/wenjuan/tupian/underline-1777360976648.svg"
          mode=""
          style="width: 18px; height: 18px; cursor: pointer; margin-right: 15px"
          @click="execCommand('underline')"
        />
        <div class="color-picker-wrapper">
          <img
            v-if="menus.includes('foreColor')"
            src="https://ossfastmake.mustke.com/wenjuan/tupian/06-1778228586208.svg"
            mode=""
            style="
              width: 18px;
              height: 18px;
              cursor: pointer;
              margin-right: 15px;
            "
            @click="toggleColorPicker"
          />

          <div v-if="showColorPicker" class="color-picker-container">
            <!-- 预设颜色 -->
            <div class="color-presets">
              <button
                v-for="(color, index) in presetColors"
                :key="index"
                class="preset-color"
                :style="{
                  backgroundColor: color,
                  borderColor: getContrastColor(color),
                }"
                :title="color"
                @click="selectPresetColor(color)"
              ></button>
            </div>
          </div>
        </div>
      </div>
      <div @click="clear" class="clear-btn">清空</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyEditor",
  props: {
    value: {
      type: String,
      default: "",
    },
    menus: {
      type: Array,
      default: () => [
        "image", // 图片
        "bold", // 加粗
        "underline", // 下划线
        "foreColor", // 字体颜色
      ],
    },
    // 🔥 新增：支持外部传入 placeholder
    placeholder: {
      type: String,
      default: "请输入内容...",
    },
  },
  data() {
    return {
      editorRef: null,
      showColorPicker: false,
      // RGB 值
      rgbValues: {
        r: 255,
        g: 51,
        b: 51,
      },
      // 预设颜色（全部使用 RGB 格式）
      presetColors: [
        "rgb(255, 255, 255)",
        "rgb(0, 0, 0)",
        "rgb(72, 82, 105)",
        "rgb(0, 102, 255)",
        "rgb(0, 204, 255)",
        "rgb(0, 204, 102)",
        "rgb(255, 51, 51)",
        "rgb(255, 153, 0)",
        "rgb(255, 204, 0)",
        "rgb(204, 51, 255)",
      ],
      lastRange: null, // 🔥 用来记住光标位置
    };
  },
  computed: {
    // 当前颜色（RGB格式）
    currentColor() {
      return `rgb(${this.rgbValues.r}, ${this.rgbValues.g}, ${this.rgbValues.b})`;
    },
  },
  mounted() {
    this.editorRef = this.$refs.editor;

    // 🔥 新增：实时记住光标位置
    this.editorRef.addEventListener("mouseup", () => {
      this.saveRange();
    });
    this.editorRef.addEventListener("keyup", () => {
      this.saveRange();
    });

    // 初始化内容，先转换为标准格式
    if (this.value) {
      const convertedContent = this.convertToStandardFormat(this.value);
      this.editorRef.innerHTML = convertedContent;
    }

    // 监听粘贴事件
    this.editorRef.addEventListener("paste", this.handlePaste);

    // 点击外部关闭颜色选择器
    document.addEventListener("click", this.closeColorPickerOnOutside);
  },
  beforeDestroy() {
    this.editorRef.removeEventListener("paste", this.handlePaste);
    document.removeEventListener("click", this.closeColorPickerOnOutside);
  },
  // watch: {
  //   value(newVal) {
  //     setTimeout(() => {
  //       const convertedContent = this.convertToStandardFormat(newVal);
  //       if (this.editorRef && this.editorRef.innerHTML !== convertedContent) {
  //         this.editorRef.innerHTML = convertedContent;
  //       }
  //     }, 0);
  //   },
  // },
  methods: {
    handleCaseProblemImg() {
      this.$emit("insertImg");
    },
    // 🔥 保存光标位置
    saveRange() {
      const sel = window.getSelection();
      if (sel.rangeCount > 0) {
        this.lastRange = sel.getRangeAt(0);
      }
    },
    /**
     * 将十六进制颜色转换为 RGB 格式
     * @param {string} hex - 十六进制颜色值
     * @returns {string} RGB 格式颜色值
     */
    hexToRgb(hex) {
      hex = hex.replace(/^#/, "");
      if (hex.length === 3) {
        hex = hex
          .split("")
          .map((c) => c + c)
          .join("");
      }
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `rgb(${r}, ${g}, ${b})`;
    },

    /**
     * 将富文本转换为标准格式：<p><strong style="color: rgb(xxx,xxx,xxx);"><u>内容</u></strong></p>
     * @param {string} html - 原始 HTML 内容
     * @returns {string} 标准化后的 HTML 内容
     */
    convertToStandardFormat(html) {
      if (!html) return "";

      let result = html;

      // 1. 将 <font color="xxx"> 转换为 <span style="color: xxx;">
      const fontColorRegex =
        /<font\s+color=["']([^"']+)["']\s*>(.*?)<\/font>/gi;
      result = result.replace(fontColorRegex, (match, color, content) => {
        // 转换颜色格式
        let rgbColor = color;
        if (/^#([0-9a-fA-F]{3,6})$/.test(color)) {
          rgbColor = this.hexToRgb(color);
        }
        return `<span style="color: ${rgbColor};">${content}</span>`;
      });

      // 2. 移除多余的标签，保留 strong、u、span
      // 这里可以根据需要添加更多的清理逻辑

      // 3. 确保内容被 <p> 标签包裹
      // 检查是否已经有 <p> 标签包裹
      if (!result.trim().startsWith("<p>")) {
        // 处理换行，将 <br> 转换为段落分隔
        const parts = result.split(/<br\s*\/?>/gi).filter((p) => p.trim());
        if (parts.length > 0) {
          result = parts.map((p) => `<p>${p.trim()}</p>`).join("");
        } else {
          result = `<p>${result.trim()}</p>`;
        }
      }

      // 4. 将 <span style="color: xxx;"> 移动到 <strong> 标签内
      // 匹配 <strong><span style="color: xxx;">内容</span></strong> 或类似结构
      const spanInStrongRegex =
        /<strong>(.*?)<span\s+style=["']color:\s*([^"']+);?["']\s*>(.*?)<\/span>(.*?)<\/strong>/gi;
      result = result.replace(
        spanInStrongRegex,
        (match, before, color, content, after) => {
          return `<strong style="color: ${color};"><u>${before}${content}${after}</u></strong>`;
        },
      );

      // 5. 处理没有 span 的情况：<strong><u>内容</u></strong>
      const strongURegex = /<strong>(.*?)<u>(.*?)<\/u>(.*?)<\/strong>/gi;
      result = result.replace(strongURegex, (match, before, content, after) => {
        return `<strong style="color: rgb(0, 0, 0);"><u>${before}${content}${after}</u></strong>`;
      });

      // 6. 清理多余的空标签
      result = result.replace(/<([a-z]+)\s*><\/\1>/gi, "");

      return result;
    },

    /**
     * 格式化输出为标准格式
     * @param {string} html - 编辑器内容
     * @returns {string} 格式化后的内容
     */
    formatOutput(html) {
      if (!html) return "";

      let result = html;

      // 移除编辑器自动添加的 <br> 标签
      result = result.replace(/<br\s*\/?>/gi, "");

      // 确保内容被 <p> 标签包裹
      if (!result.trim().startsWith("<p>")) {
        result = `<p>${result.trim()}</p>`;
      }

      // 确保 strong 标签包含 style 属性
      const strongRegex = /<strong((?!\s+style=)[^>]*)>/gi;
      result = result.replace(strongRegex, (match, attrs) => {
        // 检查是否已有 style 属性
        if (attrs && attrs.includes("style=")) {
          return match;
        }
        return `<strong${attrs ? attrs : ""} style="color: rgb(0, 0, 0);">`;
      });

      // 确保 strong 内有 u 标签
      const strongContentRegex = /<strong([^>]*)>([^<]+)<\/strong>/gi;
      result = result.replace(strongContentRegex, (match, attrs, content) => {
        return `<strong${attrs}>${content}</strong>`;
      });

      return result;
    },

    // 获取图标颜色
    getIconColor() {
      return "rgb(102, 102, 102)";
    },

    // 获取对比色
    getContrastColor(color) {
      const match = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
      if (match) {
        const r = parseInt(match[1]);
        const g = parseInt(match[2]);
        const b = parseInt(match[3]);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 128 ? "rgb(102, 102, 102)" : "rgb(255, 255, 255)";
      }
      return "rgb(102, 102, 102)";
    },

    // 执行富文本命令
    execCommand(command, value = null) {
      document.execCommand(command, false, value);
      this.editorRef.focus();
      this.emitInput();
    },

    // 切换颜色选择器显示
    toggleColorPicker(event) {
      event.stopPropagation();
      this.showColorPicker = !this.showColorPicker;
    },

    // 关闭颜色选择器
    closeColorPicker() {
      this.showColorPicker = false;
    },

    // 点击外部关闭颜色选择器
    closeColorPickerOnOutside(event) {
      const colorPickerWrapper = this.$el.querySelector(
        ".color-picker-wrapper",
      );
      if (colorPickerWrapper && !colorPickerWrapper.contains(event.target)) {
        this.showColorPicker = false;
      }
    },

    // 从 RGB 值更新颜色
    updateColorFromRGB() {
      this.rgbValues.r = Math.max(
        0,
        Math.min(255, parseInt(this.rgbValues.r) || 0),
      );
      this.rgbValues.g = Math.max(
        0,
        Math.min(255, parseInt(this.rgbValues.g) || 0),
      );
      this.rgbValues.b = Math.max(
        0,
        Math.min(255, parseInt(this.rgbValues.b) || 0),
      );
    },

    // 选择预设颜色
    selectPresetColor(color) {
      const match = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
      if (match) {
        this.rgbValues.r = parseInt(match[1]);
        this.rgbValues.g = parseInt(match[2]);
        this.rgbValues.b = parseInt(match[3]);
      }
      this.applyColor(color);
      this.showColorPicker = false;
    },

    // 应用颜色到选中文字
    applyColor(color) {
      this.editorRef.focus();

      // 使用 styleWithCSS 命令确保使用 style 属性而不是标签
      document.execCommand("styleWithCSS", false, true);
      document.execCommand("foreColor", false, color);
      document.execCommand("styleWithCSS", false, false);

      this.emitInput();
      this.showColorPicker = false;
    },

    // 在光标位置插入下划线占位符
    insertPlaceholder() {
      if (!this.editorRef) return;

      const selection = window.getSelection();
      let range;

      // 🔥 优先使用保存的光标位置（解决父组件调用丢失焦点问题）
      if (this.lastRange) {
        range = this.lastRange;
      } else if (selection.rangeCount > 0) {
        range = selection.getRangeAt(0);
      } else {
        range = document.createRange();
        range.selectNodeContents(this.editorRef);
        range.collapse(false);
      }

      // 检查是否在编辑器内
      if (!this.editorRef.contains(range.commonAncestorContainer)) {
        range.selectNodeContents(this.editorRef);
        range.collapse(false);
      }

      // 插入内容
      range.deleteContents();
      const textNode = document.createTextNode("____");
      range.insertNode(textNode);
      range.collapse(false);

      // 恢复选区
      selection.removeAllRanges();
      selection.addRange(range);

      this.emitInput();
    },
    // 检查当前选区是否应用了指定格式
    isFormatActive(command) {
      return document.queryCommandState(command);
    },
    // 处理输入事件
    handleInput() {
      this.emitInput();
    },

    // 处理鼠标抬起事件
    handleMouseUp() {
      this.$emit("update:format", {
        bold: this.isFormatActive("bold"),
        underline: this.isFormatActive("underline"),
        justifyLeft: this.isFormatActive("justifyLeft"),
      });
    },

    // 处理粘贴事件
    handlePaste(event) {
      event.preventDefault();
      const text =
        event.clipboardData.getData("text/html") ||
        event.clipboardData.getData("text/plain");
      const convertedText = this.convertToStandardFormat(text);
      document.execCommand("insertHTML", false, convertedText);
    },

    // 触发 input 事件（输出格式化后的内容）
    emitInput() {
      if (this.editorRef) {
        const content = this.formatOutput(this.editorRef.innerHTML);
        this.$emit("input", content);
      }
    },

    // 获取纯文本内容
    getText() {
      return this.editorRef ? this.editorRef.innerText : "";
    },

    // 清空内容
    clear() {
      if (this.editorRef) {
        this.editorRef.innerHTML = "";
        this.emitInput();
      }
    },
    handleKeyDown(e) {
      if (this.editorRef.innerText.trim() === "") {
        setTimeout(() => {
          const sel = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(this.editorRef);
          range.collapse(false);
          sel.removeAllRanges();
          sel.addRange(range);
        }, 0);
      }
    },
  },
};
</script>

<style scoped>
.my-editor {
  /* border: 1px solid rgb(224, 224, 224); */
  /* border-radius: 4px; */
  /* overflow: hidden; */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.toolbar {
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: rgb(245, 245, 245);
  border-bottom: 1px solid rgb(224, 224, 224);
  gap: 4px;
  flex-wrap: wrap;
}

.toolbar-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.toolbar-btn:hover {
  background-color: rgb(232, 240, 254);
}

.toolbar-btn.active {
  background-color: rgb(24, 144, 255);
  color: rgb(255, 255, 255);
}

.color-picker-wrapper {
  position: relative;
}

.color-btn {
  font-weight: bold;
}

.color-picker-container {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  padding: 12px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(224, 224, 224);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  min-width: 200px;
}

.rgb-inputs {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 12px;
}

.rgb-inputs label {
  font-size: 12px;
  font-weight: 500;
}

.rgb-input {
  width: 50px;
  height: 28px;
  padding: 0 6px;
  border: 1px solid rgb(217, 217, 217);
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
  outline: none;
}

.rgb-input:focus {
  border-color: rgb(24, 144, 255);
}

.color-preview {
  width: 100%;
  height: 40px;
  border-radius: 4px;
  margin-bottom: 12px;
  border: 1px solid rgb(224, 224, 224);
}

.color-presets {
  padding: 8px;
  display: grid;
  justify-content: flex-start;
  grid-template-columns: repeat(10, 1fr);
  grid-gap: 5px;
}

.preset-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #dcdde0;
}

.preset-color:hover {
  transform: scale(1.1);
}

.toolbar-divider {
  width: 1px;
  height: 20px;
  background-color: rgb(224, 224, 224);
  margin: 0 4px;
}

.align-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder-btn {
  width: auto;
  padding: 0 8px;
  font-family: monospace;
}

.placeholder-btn:hover {
  background-color: rgb(232, 240, 254);
}

.insert-text-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.insert-text-input {
  height: 28px;
  padding: 0 8px;
  border: 1px solid rgb(217, 217, 217);
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
  width: 150px;
}

.insert-text-input:focus {
  border-color: rgb(24, 144, 255);
}

.insert-text-input::placeholder {
  color: rgb(153, 153, 153);
}

.insert-btn {
  width: auto;
  padding: 0 12px;
  background-color: rgb(24, 144, 255);
  color: rgb(255, 255, 255);
}

.insert-btn:hover {
  background-color: rgb(64, 169, 255);
}

.editor-content {
  min-height: 60px;
  /* padding: 12px; */
  outline: none;
  line-height: 1.6;
  font-size: 14px;
  color: rgb(51, 51, 51);
  text-align: left;
}

.editor-content:focus {
  outline: none;
}

.editor-content:empty:before {
  content: attr(data-placeholder);
  color: #4c4a56;
  pointer-events: none;
  font-size: 14px;
}

.editor-content:empty:before {
  content: attr(data-placeholder);
  color: rgb(153, 153, 153);
}
</style>



// WEBPACK FOOTER //
// src/components/MyEditor/index.vue